<template>
  <div class="checked-phone-number__wrap" v-if="haveCheckedNumbers">
    <p class="checked-phone-number__title">{{ checkNumberTitle }}</p>
    <div class="checked-phone-number__list">
      <zm-tag
        v-for="item in checkedPhoneNumberList"
        :closable="showClear(item)"
        :key="item.phoneNumber"
        class="checked-phone-number__list--item"
        :delete-text="`remove ${item.displayName} button`"
        @close="removeNumber(item.phoneNumber)">
        {{ item.displayName }}
        <span
          class="checked-phone-number__list--item__label"
          v-if="item.type === phoneNumberTypeMap.tollFree">
          {{ $t('billing.pbx.toll_free.title') }}
        </span>
      </zm-tag>
    </div>
  </div>
</template>

<script>
import { phoneNumberTypeMap } from '@/plans/ZOOM_PHONE/helper/constants';

export default {
  name: 'PhoneNumberCheckedList',
  props: {
    checkedPhoneNumberList: {
      type: Array,
      default: () => [],
    },
    checkedLocalNumberList: {
      type: Array,
      default: () => [],
    },
    localNumberShowClear: {
      type: Boolean,
    },
  },
  data() {
    return {
      phoneNumberTypeMap,
    };
  },
  computed: {
    checkNumberTitle() {
      const count = this.checkedPhoneNumberList.length;
      return this.$t('billing.pbx.checked_number_title', [count]);
    },
    isOnlyOneLocalNumber() {
      return this.checkedLocalNumberList?.length === 1;
    },
    haveCheckedNumbers() {
      return this.checkedPhoneNumberList?.length;
    },
  },
  methods: {
    removeNumber(phoneNumber) {
      this.$emit('removeNumber', phoneNumber);
    },
    showClear(item) {
      if (item.type !== phoneNumberTypeMap.local) {
        return true;
      }

      return this.localNumberShowClear;
    },
  },
};
</script>

<style lang="scss">
@import "./style/checked-number-list.scss";
</style>
